import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/PTZ_Tour/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SetPtzPerm';
import PTZTourTable from 'components/Web_User_Interface/1440p_Series/Features/PTZ_Tour/ptzTourTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Features Menü // PTZ Tour",
  "path": "/Web_User_Interface/1440p_Serie/Features/PTZ_Tour/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Deaktivieren Sie den Kalibrierungslauf Ihrer Kamera beim Start (deaktiviert auch die gespeicherten Positionen). Lassen Sie Ihre Kamera nach einem Neustart in eine gespeicherte Position gehen oder beschränken Sie den Bereich der Schwenk- und Neigebewegung auf Datenschutzprobleme.",
  "image": "./WebUI_1440p_SearchThumb_Features_PTZ_Tour.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_PTZ_Tour.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Features Menü // PTZ Tour' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Deaktivieren Sie den Kalibrierungslauf Ihrer Kamera beim Start (deaktiviert auch die gespeicherten Positionen). Lassen Sie Ihre Kamera nach einem Neustart in eine gespeicherte Position gehen oder beschränken Sie den Bereich der Schwenk- und Neigebewegung auf Datenschutzprobleme.' image='/images/Search/WebUI_1440p_SearchThumb_Features_PTZ_Tour.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Features_PTZ_Tour.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/PTZ_Tour/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/PTZ_Tour/' crumbLabel="PTZ Tour" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/b97f6/1440p_Settings_Features_PTZ_Tour.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "58.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAA7rAAAO6wFxzYGVAAACP0lEQVQoz2WSS08TYRSG+y8kYijgBdppY6VFQii9UoXSzsx3nZmWFoskJC5IdOVKjSyMsbLwH6hxo0tJTPxzj5lpEaqLJ+fMl8wz57zzpXK5HNlshtz9NZrH72k9+0Tl+CNbow+Uj8b/sTUas300pnlyjjg9p1zeZm7uBvPz8ywuLpKKhZnMKvlCiejNDw7e/SI8+4l5e4E9m3Ktj8/DswuOxr8ZvP7G5maZu3fu4WRzrKyskspms8Q4Tha/26YfakIjiKwkMiLpE7Q/OZ8+W+XR3d+lvFWnWmlSq7YoFh+SchwnEcaT+kIQ9foEYZigjUEpjdIGpS/rpNc2QEhDs7ZDtTKRFtfWr4Rx9X2fIAiw1mISmcQak/QzaIUOh8igT2evRr3WmBVmMplE6Hke1gbJS7E4iHqEUQ+lFFLKGYQQGO1hdZ3qdi0RluKVLzOMV97vdOh2u7iui5ICEx1iDp5ijU4+FE9+RYDRArddpVap0WrUWS/9M2FnRigxQYQenEyFdgZtLH2rUO0GjWolERaLpdkJu+0uvusnWcZCbUN0NEwyM8b+zTDOVSrNk9DyoufSrNfZabQolTYm9zCezll1cEcu4lAgPYmQIslJCH9SfRfhufjCxxUCN87S95CNDYoPChQKa2QzzrVr4+RwlYs0k8BnfoLSyGCADIdYZRl4PkOp6OztcfPWAgsLE9Lp9NXK+Xwer+shxVQopjLfQ0QjzMvPiFffOT14ztdGiy+7LoePHpO+vczy0hJLU/4A3ZvD6GqQsfoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/e4706/1440p_Settings_Features_PTZ_Tour.avif 230w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/d1af7/1440p_Settings_Features_PTZ_Tour.avif 460w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/7f308/1440p_Settings_Features_PTZ_Tour.avif 920w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/44a65/1440p_Settings_Features_PTZ_Tour.avif 958w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/a0b58/1440p_Settings_Features_PTZ_Tour.webp 230w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/bc10c/1440p_Settings_Features_PTZ_Tour.webp 460w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/966d8/1440p_Settings_Features_PTZ_Tour.webp 920w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/cb8de/1440p_Settings_Features_PTZ_Tour.webp 958w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/81c8e/1440p_Settings_Features_PTZ_Tour.png 230w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/08a84/1440p_Settings_Features_PTZ_Tour.png 460w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/c0255/1440p_Settings_Features_PTZ_Tour.png 920w", "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/b97f6/1440p_Settings_Features_PTZ_Tour.png 958w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/7ceb266cfe6b0afb25c76833bceb3d6c/c0255/1440p_Settings_Features_PTZ_Tour.png",
              "alt": "Web User Interface - 1440p Series - Features PTZ Tour",
              "title": "Web User Interface - 1440p Series - Features PTZ Tour",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <PTZTourTable mdxType="PTZTourTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Um die Rundfahrt zu beginnen, kehren Sie bitte zum Live-Video zurück und öffnen Sie das Menü mit den voreingestellten Positionen oberhalb des Videos. Klicken Sie auf `}<strong parentName="p">{`Tour`}</strong>{`, um die Tour zu starten:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "870px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/3f3b9/1440p_Settings_Features_PTZ_Tour_b.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "13.478260869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAAwElEQVQI1z2OMWrDQBBFdUeh3EDoCkoTSJecwUTIqQPGKRIVLpQ+VwgxuDE4Aq2lXe/srvSCF9sfHvNnij8/EXtiCoHgfZzOOUSEcL5ddu89YZ65ar54pRRt21KWJWmakmUZiRpG9EnQxiLi0FozjiPW2ogxBvGC/zsgnw3z5JmmEAP7vqdpmhiY5zlFUZA8vP3y/L7lcbXj4+ub+mVBXS+pqipSL1/pNk+wznGLO8LmnmH/gxoMx6O6PT237bqOf9450klh+9nxAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/e4706/1440p_Settings_Features_PTZ_Tour_b.avif 230w", "/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/d1af7/1440p_Settings_Features_PTZ_Tour_b.avif 460w", "/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/36684/1440p_Settings_Features_PTZ_Tour_b.avif 870w"],
              "sizes": "(max-width: 870px) 100vw, 870px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/a0b58/1440p_Settings_Features_PTZ_Tour_b.webp 230w", "/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/bc10c/1440p_Settings_Features_PTZ_Tour_b.webp 460w", "/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/bf818/1440p_Settings_Features_PTZ_Tour_b.webp 870w"],
              "sizes": "(max-width: 870px) 100vw, 870px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/81c8e/1440p_Settings_Features_PTZ_Tour_b.png 230w", "/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/08a84/1440p_Settings_Features_PTZ_Tour_b.png 460w", "/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/3f3b9/1440p_Settings_Features_PTZ_Tour_b.png 870w"],
              "sizes": "(max-width: 870px) 100vw, 870px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/21a9ef1af0c2f1548cfe4e7d279c23da/3f3b9/1440p_Settings_Features_PTZ_Tour_b.png",
              "alt": "Web User Interface - 1440p Series - Features PTZ Tour",
              "title": "Web User Interface - 1440p Series - Features PTZ Tour",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      